export const userAuthenticationSelector = (state) => state.userAuthentication;

export const isPrimeUserSelector = (state) => state.userAuthentication?.usersResponse?.membership;
